const directive = function() {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {	
			var url;

			element.on('click', function(e) {
				e.preventDefault();
				url = this.href;
    			window.open(url, "_system");
			})
		}
	};
};

export default directive;


// WEBPACK FOOTER //
// ./app/shared/directives/openInSafari.directive.js